export const ColorSchemeDefault = {
    "palettes": [
        {
            "id": "palette1",
            "ranges": ["#E6F2FF", "#CCE5FF", "#B3D9FF", "#99CCFF", "#80BFFF"]
        },
        {
            "id": "palette2",
            "ranges": ["#E6E6E6", "#CCCCCC", "#B3B3B3", "#999999", "#808080"]
        },
        {
            "id": "palette3",
            "ranges": ["#FFFF99", "#FFFF66", "#FFFF33", "#FFFF00", "#FFCC00"]
        },
        {
            "id": "palette4",
            "ranges": ["#FFD9E6", "#FFCCE5", "#FFB3D9", "#FF99CC", "#FF80BF"]
        },
        {
            "id": "palette5",
            "ranges": ["#D9FFCC", "#BFFF99", "#99FF66", "#80FF33", "#66FF00"]
        },
        {
            "id": "palette6",
            "ranges": ["#D9FFCC", "#BFFF99", "#99FF66", "#80FF33", "#66FF00"]
        },
        {
            "id": "palette7",
            "ranges": ["#1D5D9B", "#1A4B7D", "#173B63", "#132D4E", "#0F233D"]
        },
        {
            "id": "palette8",
            "ranges": ["#64B3FF", "#4C94E6", "#3777CC", "#265EAC", "#1B478E"]
        },
        {
            "id": "palette9",
            "ranges": ["#9AD6F0", "#67C6E3", "#378CE7", "#5356FF", "#912BBC"]
        },
        {
            "id": "palette10",
            "ranges": ["#FFD23F", "#FFC873", "#FFD18D", "#FFDBA7", "#FFE5C1"]
        },
        {
            "id": "palette11",
            "ranges": ["#029C36", "#03B149", "#04C55B", "#05D86E", "#06EA81"]
        },
        {
            "id": "palette12",
            "ranges": ['#00909E', '#1D5D9B', '#FFD23F', '#FF7F50', '#4CAF50', '#FF5733']
        },
        {
            "id": "palette13",
            "ranges": ['#DAA65C', '#BF8F4A', '#A37738', '#885F26', '#6E4714']
        },
        {
            "id": "palette14",
            "ranges": ['#F5F78B', '#E9E25F', '#DCCF33', '#C0B708', '#A39D00']
        },
        {
            "id": "palette15",
            "ranges": ['#ADE0A2', '#99C787', '#85B46D', '#719352', '#5D8238']
        },
        {
            "id": "palette16",
            "ranges": ['#ACD3F9', '#93BBF3', '#7AA2ED', '#618AE7', '#4872E1']
        },
        {
            "id": "palette17",
            "ranges": ['#50CD7A', '#44B46E', '#389C62', '#2C8356', '#206B4A']
        },
        {
            "id": "palette18",
            "ranges": ["#1D5D9B", "#4CB4F2", "#88FFFF", "#C4FFFF", "#FFFFFF"]
        },
        {
            "id": "palette19",
            "ranges": ["#3777CC", "#1B4D99", "#002B66", "#001833", "#000C19"]
        },
        {
            "id": "palette21",
            "ranges": ['#ECF6FF', '#CCCCCC', '#FFBD59', '#FFD23F', '#000000']
        },
        {
            "id": "palette22",
            "ranges": ["#5C5C5C", "#9D9C9C", "#fcb152", "#ff588e", "#645C5C", "#ffcd7f", "#ff79a7"]
        },
        {
            "id": "palette23",
            "ranges": ["#ff86be", "#38bc57", "#1D5D9B", "#00d575", "#00a9dc"]
        },
        {
            "id": "palette24",
            "ranges": ["#9D9C9C", "#38bc57", "#1D5D9B", "#00d575", "#00a9dc"]
        },
        {
            "id": "palette25",
            "ranges": ["#fcb152", "#38bc57", "#1D5D9B", "#00d575", "#00a9dc"]
        },
        {
            "id": "palette26",
            "ranges": ["#ff588e", "#38bc57", "#1D5D9B", "#00d575", "#00a9dc"]
        },
        {
            "id": "palette27",
            "ranges": ["#645C5C", "#38bc57", "#1D5D9B", "#00d575", "#00a9dc"]
        },
        {
            "id": "palette28",
            "ranges": ["#FFFFFF"]
        }
    ],
    "themes": [
        {
            "id": "colorTheme1",
            "name": "colorTheme1",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette8"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette16"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette18", "palette19", "palette10"]
                },
                {
                    "type": "line",
                    "ranges": ["palette1", "palette3", "palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette7", "palette8"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette12"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette13", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "treemap",
                    "ranges": ["palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17", "palette7", "palette8", "palette9", "palette10", "palette12", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette21"]
                }
            ],
            "sidebar": {
                "ranges": ["palette28"]
            }
        },
        {
            "id": "colorTheme2",
            "name": "colorTheme2",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette5"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette8", "palette7", "palette4", "palette9", "palette12"]
                },
                {
                    "type": "line",
                    "ranges": ["palette10", "palette11", "palette13"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette9", "palette13", "palette9", "palette10"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette12"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette8", "palette9", "palette10", "palette11", "palette12",]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette13", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
            ]
        },
        {
            "id": "colorTheme3",
            "name": "colorTheme3",
            "charts": [
                {
                    "type": "bar",
                    "ranges": ["palette16", "palette17"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette16"]
                },
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette11", "palette10"]
                },
                {
                    "type": "line",
                    "ranges": ["palette19", "palette10", "palette9", "palette12"]
                }
            ]
        },
        {
            "id": "colorTheme4",
            "name": "colorTheme4",
            "charts": [
                {
                    "type": "bar",
                    "ranges": ["palette1"]
                },
            ]
        }
    ]
}